import classNames from 'classnames';

import { isFalsy } from 'lib/Helpers';

import * as styles from '../SortingArrows.scss';

/**
 * Retrieves Props for <TrendArrow /> Components in <SortingArrows />
 * @function getArrowProps
 * @param {Object} arrowData
 * @prop {String} arrowDirection
 * @prop {String} currentField
 * @prop {String} sortBy
 * @prop {String} sortDirection
 * @return {Object}
 */
const getArrowProps = arrowData => {
  if (isFalsy(arrowData)) return { className: styles.arrow, color: '#AFC1E1' };

  const { arrowClassName, arrowDirection, currentField, sortBy, sortDirection } = arrowData;
  const isActive = currentField === sortBy && sortDirection === arrowDirection;

  return {
    className: classNames(
      styles.arrow,
      { [styles.arrowDown]: arrowDirection === 'DESC' },
      { [styles.arrowActive]: isActive },
      arrowClassName,
    ),
    color: isActive ? '#105EEB' : '#AFC1E1',
  };
};

export default getArrowProps;
